// Tracks tasks the user just ran a Pomodoro on, so we can render a tiny
// "Recently focused" pill next to the row for a short while afterwards.
// Stored locally — no backend needed; this is a soft dopamine cue, not a
// stat we want polluting the server's analytics.

const STORAGE_KEY = "mochi.recentlyFocused.v1";
const TTL_MS = 24 * 60 * 60 * 1000; // 24h

function readRaw() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return (parsed && typeof parsed === "object") ? parsed : {};
    } catch {
        return {};
    }
}

function writeRaw(map) {
    // localStorage can throw in Safari private mode — silent ok, the cache
    // just won't survive across reloads for that one session.
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(map)); } catch { /* storage unavailable */ }
}

// Returns a {id: timestampMs} map with any expired entries dropped.
export function getRecentlyFocusedMap() {
    const map = readRaw();
    const now = Date.now();
    const fresh = {};
    let mutated = false;
    for (const [id, ts] of Object.entries(map)) {
        if (typeof ts === "number" && now - ts < TTL_MS) {
            fresh[id] = ts;
        } else {
            mutated = true;
        }
    }
    if (mutated) writeRaw(fresh);
    return fresh;
}

// Mark a task as just focused; returns the updated map for callers that
// want to bump React state synchronously without a fresh read.
export function markFocused(id) {
    if (!id) return readRaw();
    const map = getRecentlyFocusedMap();
    map[id] = Date.now();
    writeRaw(map);
    return { ...map };
}

export function isRecentlyFocused(id, map) {
    if (!id || !map) return false;
    const ts = map[id];
    return typeof ts === "number" && Date.now() - ts < TTL_MS;
}
